import styled from "styled-components";
import * as variables from "pubweb-smokey/dist/components/GridSystem/_vars_widths";
import Colors from "pubweb-smokey/dist/colors";

export const FooterStyles = styled.footer`
  @media screen and (min-width: ${variables.mobile_width_percentage}px) {
    footer {
      background-color: #96d3ce;
      color: #fff;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 11px;
      font-weight: 700;
      margin: 0;
      padding: 1rem 0 5rem 0;
      text-align: center;

      div {
        display: inline;
      }
      div:not(:last-child) {
        border-right: solid 2px #fff;
        margin-right: 1rem;
        padding-right: 1rem;
      }
      a {
        color: #fff;
        cursor: pointer;
        text-decoration: none;
        :hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    footer {
      font-size: 13px;
      padding: 1rem 0 7.5rem 0;
    }
  }
`;
